import { Navigate, Route, Routes } from "react-router-dom";

import { useVisualViewport } from "./hooks/useVisualViewport.js";
import { useSession } from "./session/SessionContext.js";
import { AdminView } from "./views/AdminView.js";
import { LoginView } from "./views/LoginView.js";
import { QueueView } from "./views/QueueView.js";

/**
 * The application shell.
 *
 * Routing is deliberately flat: a support tool is a queue and a conversation, and
 * anything more elaborate would be structure without purpose.
 */
export function App() {
  const { status, principal } = useSession();

  // Keeps the reply box above the on-screen keyboard when an agent answers from a
  // phone. A no-op on a desktop, where no keyboard takes half the screen.
  useVisualViewport();

  if (status === "loading") {
    return (
      <div className="centered">
        <p className="muted">Signing you in…</p>
      </div>
    );
  }

  if (status === "anonymous") return <LoginView />;

  // A customer or guest holding a session cannot use this tool. Rendering an empty
  // dashboard would be confusing; saying so plainly is not.
  if (principal?.type !== "agent") {
    return (
      <div className="centered">
        <div className="card">
          <h1>Support staff only</h1>
          <p className="muted">
            This dashboard is for Island Peptides support staff. Your account does not have access.
          </p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/conversations/:conversationId" element={<QueueView />} />
      <Route path="/conversations" element={<QueueView />} />
      {/* Nested, because the admin area has its own tabs. Every screen inside is
          gated again on its own permission, and the API enforces them regardless. */}
      <Route path="/admin/*" element={<AdminView />} />
      <Route path="*" element={<Navigate to="/conversations" replace />} />
    </Routes>
  );
}
